import { apiClient } from '@/shared/api/client'

export async function getLeads(params = {}) {
  const response = await apiClient.get('/marketing/leads', { params })
  return response.data
}

export async function getLeadById(id) {
  const response = await apiClient.get(`/marketing/leads/${id}`)
  return response.data
}

export async function createLead(payload) {
  const response = await apiClient.post('/marketing/leads', payload)
  return response.data
}

export async function updateLead(id, payload) {
  const response = await apiClient.put(`/marketing/leads/${id}`, payload)
  return response.data
}

export async function deleteLead(id) {
  const response = await apiClient.delete(`/marketing/leads/${id}`)
  return response.data
}

export async function bulkUploadLeads(file) {
  const formData = new FormData()
  formData.append('file', file)

  const response = await apiClient.post(
    '/marketing/leads/bulk-upload',
    formData,
    {
      headers: {
        'Content-Type': undefined,
      },
    },
  )

  return response.data
}
